import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function UsageStatistics({applicationUsageBarGraph}) {
  return (
    <div className="bg-white shadow rounded-xl p-5 border">
         
          <ResponsiveContainer width="100%" height={380}>
            <BarChart data={applicationUsageBarGraph}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis
                label={{
                  value: "hours",
                  angle: -90,
                  position: "insideLeft",
                  style: { textAnchor: "middle" },
                }}
              />
              <Tooltip />
              <Legend
                verticalAlign="bottom"
                align="center"
                wrapperStyle={{ paddingTop: "20px" }}
              />
              <Bar dataKey="usageHours" fill="#16A34A" name="Usage hours" />
            </BarChart>
          </ResponsiveContainer>
        </div>
  )
}
